import styled from 'styled-components';
import { lighten, darken } from 'polished';

const isCssVar = (v?: string) => !!v && v.trim().startsWith('var(');

const safeColor = (v?: string, fallback = '#00b46a') => {
  const s = (v ?? '').trim();
  return s.length ? s : fallback;
};

export const ButtonV2 = styled.button<{
  variant?: 'primary' | 'secondary';
  background?: string;
  color?: string;
}>`
  width: 100%;
  height: 56px;
  padding: 0 24px;
  font-size: 1.15rem;
  font-weight: 600;
  letter-spacing: -0.2px;
  border-radius: 14px;
  border: none;
  cursor: pointer;
  color: ${(props) => safeColor(props.color, '#fff')};

  background: ${(props) => {
    const base = safeColor(props.background, '#00D95F');

    if (isCssVar(base)) {
      return `
        linear-gradient(
          135deg,
          color-mix(in srgb, ${base} 90%, white) 0%,
          ${base} 50%,
          color-mix(in srgb, ${base} 90%, black) 100%
        )
      `;
    }

    return `
      linear-gradient(
        135deg,
        ${lighten(0.06, base)} 0%,
        ${base} 50%,
        ${darken(0.06, base)} 100%
      )
    `;
  }};

  box-shadow: ${(props) => {
    const base = safeColor(props.background, '#00D95F');

    if (isCssVar(base)) {
      return `0 4px 14px color-mix(in srgb, ${base} 40%, transparent)`;
    }

    return `0 4px 14px ${lighten(0.15, base)}66`;
  }};

  transition: all 0.2s ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: ${(props) => {
      const base = safeColor(props.background, '#00D95F');

      if (isCssVar(base)) {
        return `0 6px 20px color-mix(in srgb, ${base} 50%, transparent)`;
      }

      return `0 6px 20px ${lighten(0.15, base)}80`;
    }};
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }

  svg {
    color: currentColor;
  }
`;
